module.exports = __webpack_public_path__ + "static/img/but.47c9fe54.png";